/* global process */

angular.module("templates", []).run(["$templateCache", function($templateCache) {
  // Reusable env-backed token format for HTML partials: @@SMX_ENV:VAR_NAME@@
  const TEMPLATE_ENV_TOKENS = {
    IDS_URL: process.env.IDS_URL,
  };

  function replaceEnvTokens(templateContent, templateName) {
    return templateContent.replace(/@@SMX_ENV:([A-Z0-9_]+)@@/g, function (fullMatch, envVarName) {
      if (!Object.prototype.hasOwnProperty.call(TEMPLATE_ENV_TOKENS, envVarName)) {
        throw new Error("Unsupported template env token " + fullMatch + " in " + templateName);
      }

      const tokenValue = TEMPLATE_ENV_TOKENS[envVarName];
      if (!tokenValue) {
        throw new Error("Missing env value for token " + fullMatch + " in " + templateName);
      }

      return tokenValue;
    });
  }

  function requireAll(requireContext) {
    
    return requireContext.keys().map(function(val){
        return {
            // tpl will hold the value of your html string because thanks to wepbpack "raw-loader" **important**
            tpl:requireContext(val),

            //name is just the filename
            name : val.split('/').pop()
        };
    });
  } 

  let templates = requireAll(require.context('./../templates', true, /\.html$/));
  templates.forEach(function (template) {
    const resolvedTemplate = replaceEnvTokens(template.tpl, template.name);
    $templateCache.put(template.name, resolvedTemplate);
  });

}]);